

import React from "react";
import { Line } from "react-chartjs-2";

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import datalabels plugin

// Register Chart.js components
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  ChartDataLabels // Register the datalabels plugin
);

const Alerts = () => {
  // Chart data with labels and datasets
  const data = {
    labels: ["21/10", "22/10", "23/10", "24/10", "25/10"], // X-axis labels
    datasets: [
      {
        label: "Total",
        data: [10, 15, 90, 25, 20],
        borderColor: "#81ecec",
        backgroundColor: "#81ecec",
        fill: true,
        tension: 0.3,
        pointBackgroundColor: "#81ecec",
        pointRadius: 5,
        pointHoverRadius: 7,
      },
      {
        label: "Male",
        data: [5, 10, 55, 20, 5],
        borderColor: "#00cec9",
        backgroundColor: "#00cec9",
        fill: true,
        tension: 0.3,
        pointBackgroundColor: "#00cec9",
        pointRadius: 5,
        pointHoverRadius: 7,
      },
      {
        label: "Female",
        data: [2, 5, 10, 15, 10],
        borderColor: "#00b894",
        backgroundColor: "#00b894",
        fill: true,
        tension: 0.3,
        pointBackgroundColor: "#00b894",
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };
    const options = {
    responsive: true,
    maintainAspectRatio: false, // Allow manual height adjustment
    aspectRatio: 2,
    animations: {
      tension: {
        duration: 1000,
        easing: "easeInOutBounce",
        from: 1,
        to: 0,
        loop: false,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#000",
          font: {
            size: 12,
            weight: "bold",
          },
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}`,
        },
        backgroundColor: "#ffffff",
        titleColor: "#000",
        bodyColor: "#333",
      },
      datalabels: {
        display: false, // Set to true to show labels on the chart
        align: "end",
        anchor: "end",
        color: "#000",
        gap: 10,
        font: {
          size: 10,
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        type: "category",
        title: {
          display: false,
          text: "X-Axis Label",
          color: "#000",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          display: false,
          color: "rgba(0, 0, 0, 0.1)",
          borderDash: [5, 5],
        },
        ticks: {
          display: true,
          color: "#000",
          font: {
            size: 12,
          },
          autoSkip: true, // Automatically skip labels if needed
        },
      },
      y: {
        type: "linear",
        beginAtZero: true,
        suggestedMax:'auto', 
       
        title: {
          display: false,
          text: "Y-Axis Label",
          color: "#000",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          display: true,
          color: "rgba(0, 0, 0, 0.1)",
          borderDash: [5, 5],
        },
        ticks: {
          display: true,
          color: "#000",
          font: {
            size: 12,
          },
          stepSize: 20,
          callback: (value) => `${value}`,
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "350px"}}>
      <Line data={data} options={options} />
    </div>
  );
};

export default Alerts;
